import { ComponentProps, forwardRef, ReactNode } from "react";

type TProseWrapperProps = ComponentProps<"div"> & {
  children?: ReactNode;
  className?: string;
  editable?: boolean;
};

export const ProseWrapper = forwardRef<HTMLDivElement, TProseWrapperProps>((props, ref) => {
  const { children, className, editable, ...otherProps } = props;
  return (
    <div
      ref={ref}
      className={
        "prose prose-lg h-full max-w-none flex-1 overflow-auto [&_p]:mb-3 [&_p]:text-[15px] [&_p]:leading-[23px] [&_p]:font-normal [&_p]:text-innoveraZinc-900 [&_li]:mb-1 [&_li]:text-[15px] [&_li]:leading-[23px] [&_li]:text-innoveraZinc-900 [&_strong]:font-semibold [&_strong]:text-innoveraZinc-900 [&_h1]:mt-6 [&_h1]:mb-3 [&_h1]:text-3xl [&_h1]:font-semibold [&_h1]:pb-1 [&_h1]:text-innoveraZinc-900 [&_h2]:mt-6 [&_h2]:mb-3 [&_h2]:text-[24px] [&_h2]:leading-[32px] [&_h2]:font-semibold [&_h2]:text-innoveraZinc-900 [&_h3]:mt-6 [&_h3]:mb-3 [&_h3]:text-[20px] [&_h3]:leading-[26px] [&_h3]:font-semibold [&_h3]:text-innoveraZinc-900 [&_h4]:mt-6 [&_h4]:mb-3 [&_h4]:text-[18px] [&_h4]:leading-[24px] [&_h4]:font-semibold [&_h4]:text-innoveraZinc-900 [&_table]:border-collapse [&_table]:w-full [&_th]:border [&_th]:p-2 [&_td]:border [&_td]:p-2 " +
        className
      }
      {...otherProps}
    >
      <style>{`
      
        .ProseMirror {
          outline: none !important;
          min-height: 100%;
          font-size: 15px;
          line-height: 23px;
        }

        .ProseMirror > :first-child {
          margin-top: 0;
        }

        .ProseMirror:focus,
        .ProseMirror-focused {
          outline: none !important;
          box-shadow: none !important;
        }

        .ProseMirror p {
          white-space: pre-wrap;
          font-size: 15px;
          line-height: 23px;
        }

        .ProseMirror .isEmpty::placeholder {
          color: #000;
        }

        .ProseMirror h1 {
          font-size: 1.875rem;
          font-weight: 600;
          padding-bottom: 0.25rem;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
        }

        .ProseMirror h2 {
          font-size: 24px;
          line-height: 32px;
          font-weight: 600;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
        }

        .ProseMirror h3 {
          font-size: 20px;
          line-height: 26px;
          font-weight: 600;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
        }

        .ProseMirror h4 {
          font-size: 18px;
          line-height: 24px;
          font-weight: 600;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
        }

        .ProseMirror ul,
        .ProseMirror ol {
          padding-left: 2.5rem;
          margin: 0.5rem 0;
        }

        .ProseMirror ul {
          list-style-type: disc;
        }

        .ProseMirror ul ul {
          list-style-type: circle;
        }

        .ProseMirror ul ul ul {
          list-style-type: square;
        }

        .ProseMirror ol {
          list-style-type: decimal;
        }

        .ProseMirror li {
          margin: 0.25rem 0;
        }

        .ProseMirror li p {
          margin: 0;
        }

        /* Adjust spacing for nested lists */
        .ProseMirror li > ul,
        .ProseMirror li > ol {
          margin: 0.25rem 0;
        }

        /* Table styles */
        .ProseMirror table {
          border-collapse: collapse;
          


        }

        .ProseMirror th {
          background-color: #f8f9fa;
          font-weight: 600;
          text-align: left;
          border: 1px solid #e2e8f0;
          padding: 0.5rem;
        }

        .ProseMirror td {
          border: 1px solid #e2e8f0;
          padding: 0.5rem;
          vertical-align: top;
        }

        .ProseMirror .selectedCell {
          position: relative;
        }
        
        .ProseMirror .selectedCell:after {
          z-index: 2;
          position: absolute;
          content: "";
          left: 0; right: 0; top: 0; bottom: 0;
          background: rgba(200, 200, 255, 0.4);
          pointer-events: none;
        }
        
        /* Column resize handle */
        .ProseMirror .column-resize-handle {
          position: absolute;
          right: -2px; top: 0; bottom: -2px;
          width: 4px;
          background-color: #adf;
          pointer-events: none;
          z-index: 20;
        }
        
        .ProseMirror.resize-cursor {
          cursor: col-resize;
        }

        .tableWrapper {
        padding-left: 10px;
        overflow-x: auto;
        max-width: 100%;
        }

            
      `}</style>
      {children}
    </div>
  );
});
